import { apmAsyncScope } from "./utils";

const log = apmAsyncScope.scope("filters");
const dropUnsampledLog = log.scope("dropUnsampled");
const enrichErrorsLog = log.scope("enrichErrors");

/*                                            */
const knownFields = ["transactions", "errors"] as const;

/*                               */
const isArray = <T>(v: unknown): v is T[] => Array.isArray(v);

/*                              */
const logFormatPayloadInfo = (p: Payload): string[] =>
  knownFields.map((f) => `${f}: ${p[f]?.length ?? 0}`);

/**
 *
 *
 *
 *
 *
 *
 */
export const dropUnsampled: FilterFn = (payload) => {
  const ttt = payload[knownFields[0]];
  dropUnsampledLog.info("before processing", logFormatPayloadInfo(payload));

  /*                                */
  if (!isArray<{ sampled?: boolean }>(ttt)) return payload;

  /*                                                  */
  /*                                       */
  if (dropUnsampledLog.isEnabled()) {
    ttt.forEach((t, i) => {
      dropUnsampledLog.debug("transaction", i, "json:", JSON.stringify(t));
    });
  }

  /*                              */
  payload.transactions = ttt.filter((t) => !!t.sampled);

  /*                                                            */
  if (knownFields.every((f) => isArray(payload[f]) && payload[f].length === 0))
    return (dropUnsampledLog.info("dropped empty payload"), false);

  dropUnsampledLog.info("after processing", logFormatPayloadInfo(payload));
  return payload;
};

type APMErrorPayload = {
  context?: {
    tags?: Labels;
  };
  exception?: {
    stacktrace?: {
      abs_path?: string;
      filename?: string;
    }[];
  };
};

export const enrichErrors: FilterFn = (payload) => {
  const eee = payload[knownFields[1]];
  if (!isArray<APMErrorPayload>(eee) || eee.length < 1) return payload;

  enrichErrorsLog.info("Enriching errors in payload", eee);
  eee.forEach((e) => {
    enrichErrorsLog.debug("Anaylzing error", e);
    const stack = e.exception?.stacktrace;
    if (!isArray(stack) || stack.length < 1) return;

    const labels = new Map<string, Set<string>>();

    stack.forEach((frame) => {
      const path = frame.filename ?? frame.abs_path;
      if (typeof path !== "string" || path.length < 1) return;

      const file = path.split("/").pop();
      if (typeof file !== "string" || file.length < 1) return;

      const [team, service, bundle] = file.split(".");
      if (!team || !service || !bundle) return;

      if (!labels.has(team)) labels.set(team, new Set());
      labels.get(team)!.add(`${service}.${bundle}`);
    });

    labels.forEach((v, k) => {
      e.context ??= {};
      e.context.tags ??= {};
      e.context.tags[`${k}_error`] = [...v].join(", ");
    });
  });

  enrichErrorsLog.info("Finished enriching errors in payload", eee);
  return payload;
};
